module.exports = __webpack_public_path__ + "img/ui-ux.10192270.png";